import CustomSelect from '../../../form/custom-select';
import {debounce} from 'throttle-debounce';
import Observer from '../../../../common/scripts/observer';
import ParametricFilterContentPopup from './content-popup';
import ParametricFilterPopup from './popup';
import {PopupFacade} from '../../../popup/popupFacade';
import RangeSlider from '../../../range-slider';
import {Utils} from '../../../../common/scripts/utils';

const observer = new Observer();

class ParametricFilter {
    constructor(options) {
        /**
         * Параметры
         */
        this.options = options;

        /**
         * Целевой элемент
         */
        this.element = options.element ? options.element.querySelector('.j-parametric-filter') : null;

        /**
         * CSS-класс состояния загрузки
         * @type {string}
         */
        this.loadingClass = 'is-loading';

        /**
         * CSS-класс неактивного состояния
         * @type {string}
         */
        this.disableClass = 'is-disabled';

        /**
         * CSS-класс открытого состояния
         * @type {string}
         */
        this.openClass = 'is-open';

        /**
         * CSS-класс фиксированного поиска в области скролла
         * @type {string}
         */
        this.scrollClass = 'is-scroll';

        /**
         * Класс для элемента фильтра в состоянии загрузки
         * @type {string}
         */
        this.elemLoadingClass = 'is-filter-elem-load';

        /**
         * Задержка отложенных функций
         * @type {number}
         */
        this.debTime = 300;

        /**
         * Тип последнего запроса
         * @type {string}
         */
        this.reqType = '';

        /**
         * Текст кнопки при открытых дополнительных параметров фильтра
         * @type {string}
         */
        this.openedButtonText = 'Скрыть дополнительные параметры';

        /**
         * Текст кнопки при закрытых дополнительных параметров фильтра
         * @type {string}
         */
        this.closedButtonText = 'Дополнительные параметры';

        this.inputsForm = null;
        this.buttonCounter = null;
        this.counter = 0;
    }

    init() {
        if (!this.element) {
            return;
        }

        this._initElements();
        this._initSelects();
        this._initContentPopups();
        this._initSliders();
        this._initStart();
        this._initPopup();
        this._initWishes();

        this._bindEvents();
        this._bindCheckboxes();

        if (Utils.isMobile()) {
            this.getFilterCount();
        }
    }

    /**
     * Инит элементов
     * @private
     */
    _initElements() {
        this.form = this.element.querySelector('.j-parametric-filter__form');
        this.reset = this.element.querySelector('.j-parametric-filter__reset');
        this.submit = this.element.querySelector('.j-parametric-filter__submit');
        this.submitText = this.element.querySelector('.j-parametric-filter__submit-text');
        this.filterElems = Array.from(this.element.querySelectorAll('.j-parametric-filter__elem'));
        this.visualParamInputs = Array.from(this.element.querySelectorAll('.j-visual-param input'));
        this.additionalRow = this.element.querySelector('.j-parametric-filter__row-additional');
        this.additionalButton = this.element.querySelector('.j-parametric-filter__additional');
        this.additionalButtonText = this.additionalButton?.querySelector('.j-parametric-filter__button') || null;
        this.sectionsSelect = this.element.querySelector('.j-parametric-filter-item-section') || null;
        this.checkboxes = [...this.element.querySelectorAll('.j-parametric-filter-props')];
        this.constructorButtons = [...this.element.querySelectorAll('.j-parametric-filter-constructor')];
    }

    /**
     * Инициализация селектов
     * @private
     */
    _initSelects() {
        this.selectElements = Array.from(this.element.querySelectorAll('.j-parametric-filter__select'));
        this.selects = [];
        this.selectElements.forEach((element) => {
            const select = new CustomSelect({
                elem: element
            });

            select.init();
            this.selects.push(select);
        });
    }

    /**
     * Инициализация псевдоселектов с попапами
     * @private
     */
    _initContentPopups() {
        this.selectPopupElements = Array.from(this.element.querySelectorAll('.j-parametric-select-popup'));
        this.selectPopups = [];
        this.selectPopupElements.forEach((element) => {
            const select = new ParametricFilterContentPopup({
                elem: element
            });

            select.init();
            this.selectPopups.push(select);
        });
    }

    /**
     * Инициализация рейндж-слайдеров
     * @private
     */
    _initSliders() {
        this.rangeElements = Array.from(this.element.querySelectorAll('.j-range-slider'));
        this.ranges = {};
        this.rangeElements.forEach((element) => {
            const range = new RangeSlider();

            range.init({
                wrapper : element,
                onFinish: debounce(this.debTime, this._send.bind(this, 'filter'))
            });

            this.ranges[element.dataset.slider] = range;

            element.querySelectorAll('input').forEach((input) => {
                input.dataset.initValue = input.value;
            });
        });
    }

    _initStart() {
        if (!this.additionalRow || !this.additionalRow.dataset.startOpen || !this.additionalButton) {
            return;
        }

        // Вернуть - если необходимо будет расскрывать по кнопке
        // this.additionalRow.style.height = `${this.additionalRow.scrollHeight}px`;

        this.additionalButton.classList.add(this.openClass);
        this.additionalButtonText.innerText = this.openedButtonText;
    }

    /**
     * Инит мобильного попапа
     * @private
     */
    _initPopup() {
        this.popup = new ParametricFilterPopup(this.element);
        this.popup.init();
    }

    _initWishes() {
        this.wishes = this.element.querySelector('.j-parametric-filter__wishes') || null;
        this.wishesInput = this.wishes?.querySelector('.j-parametric-filter__wishes-input') || null;
        this.wishesTextarea = this.wishes?.querySelector('.j-parametric-filter__wishes-textarea') || null;
        this.wishesButton = this.wishes?.querySelector('.j-parametric-filter__wishes-button');

        this._bindWishes();
    }

    /**
     * Вешает обработчики событий
     * @private
     */
    _bindEvents() {
        this.form.addEventListener('submit', (event) => {
            event.preventDefault();
        });

        this.form.addEventListener('submit', () => {
            this.popup.close();
        });
        this.form.addEventListener('change', debounce(this.debTime, this._send.bind(this, 'filter')));
        this.reset.addEventListener('click', debounce(this.debTime, this._send.bind(this, 'reset')));

        if (this.additionalButton) {
            this.additionalButton.addEventListener('click', this._showAdditional.bind(this));
        }
    }

    // _TODO: Переделать тултипы
    /**
     * Вешаем обработчик доп свойств намобильных, чтобы тултипы скрывались на неактивных данных
     */
    _bindCheckboxes() {
        if (!Utils.isMobile()) {
            return;
        }

        this.checkboxes.forEach((checkbox) => {
            checkbox.addEventListener('click', (event) => {
                if (event.target.nodeName === 'INPUT') {
                    if (checkbox.classList.contains('is-checked')) {
                        const infoPin = checkbox.querySelector('.j-toggle-wrapper');

                        if (infoPin.classList.contains('is-active')) {
                            infoPin.classList.remove('is-active');
                        }
                    }

                    checkbox.classList.toggle('is-checked');
                }

                this._checkConstructor(event);
            });
        });
    }

    _checkConstructor(event) {
        if (event.target.nodeName === 'INPUT') {
            const input = event.target;
            const buttonID = input.name;
            const state = input.checked;

            const constructorButton = input.closest('.j-parametric-filter-constructor');

            if (constructorButton) {
                this.constructorButtons.forEach((item) => {
                    if (item.querySelector('input').name !== buttonID) {
                        item.querySelector('input').checked = state;
                    }
                });

                if (buttonID === 'constructor_double') {
                    this._calcInputs();

                    debounce(this.debTime, this._send('filter'));
                }
            }
        }
    }

    _bindWishes() {
        if (!this.wishesInput || !this.wishesTextarea) {
            return;
        }

        this.wishesInput.addEventListener('change', () => {
            this.wishesTextarea.value = this.wishesInput.value;
        });

        this.wishesInput.addEventListener('input', (event) => {
            this.wishesButton?.classList.toggle(this.disableClass, !event.target.value);
        });

        this.wishesTextarea.addEventListener('change', () => {
            this.wishesInput.value = this.wishesTextarea.value;
        });

        this.wishesTextarea.addEventListener('input', (event) => {
            this.wishesButton?.classList.toggle(this.disableClass, !event.target.value);
        });

        this.wishesButton?.addEventListener('click', () => {
            const wish = this.wishesInput?.value || null;

            if (!wish?.length) {
                return;
            }

            const wishButtonArray = [this.wishesButton];
            const options = {
                ...{openButtons: wishButtonArray},
                title: 'Подобрать квартиру',
                wish
            };

            const facade = new PopupFacade(options);

            facade.init();
        });
    }

    /**
     * Отправка данных
     * @param {string} reqType - тип запроса
     * @private
     */
    _send(reqType) {
        if (this.options.change) {
            this.options.change(reqType);
        }
        if (reqType === 'reset') {
            observer.publish('formReset');
        }
    }

    /**
     * Обновляет фильтры
     * @param {object} filters - данные с сервера
     * @private
     */
    _updateFilters(filters) {
        this._updateChecks(filters);

        this.selects.forEach((select) => {
            select.update(this.reqType === 'reset');
        });

        this.selectPopups.forEach((selectPopup) => {
            selectPopup.update(this.reqType === 'reset');
        });

        if (this.sectionsSelect) {
            this._updateSectionFilter(filters);
        }
    }

    /**
     * Обновление чекбоксов
     * @param {object} data - данные для обработки
     * @private
     */
    /* eslint-disable max-lines-per-function */
    _updateChecks(data) {
        Object.entries(data).forEach(([name, options]) => {
            const filter = this.element.querySelector(`[data-filter="${name}"]`);

            if (!filter) {
                return;
            }

            const isArray = Array.isArray(options.items);

            if (isArray) {
                options.items.forEach((option) => {
                    // Для массивов без вложенных массивов
                    if (!Array.isArray(option)) {
                        const input = filter.querySelector(`input[value="${option.value}"]`);

                        if (!input) {
                            return;
                        }

                        input.disabled = option.disabled;
                        input.checked = option.checked;

                        return;
                    }

                    // Для вложенных массивов
                    option.forEach((item) => {
                        const input = filter.querySelector(`input[value="${item.value}"]`);

                        if (!input) {
                            return;
                        }

                        input.disabled = item.disabled;
                        input.checked = item.checked;
                    });
                });
            } else {
                const optionsArray = Object.values(options.items);

                optionsArray.forEach((option) => {
                    // Для массивов без вложенных массивов
                    if (!Array.isArray(option)) {
                        const input = filter.querySelector(`input[value="${option.value}"]`);

                        if (!input) {
                            return;
                        }

                        input.disabled = option.disabled;
                        input.checked = option.checked;

                        return;
                    }

                    // Для вложенных массивов
                    option.forEach((item) => {
                        const input = filter.querySelector(`input[value="${item.value}"]`);

                        if (!input) {
                            return;
                        }

                        input.disabled = item.disabled;
                        input.checked = item.checked;
                    });
                });
            }
        });
    }
    /* eslint-enable max-lines-per-function */

    /**
     * Обновляет рейндж-слайдеры после того, как пришли новые данные с сервера
     * @param {object} ranges - данные с сервера
     * @private
     */
    _updateRanges(ranges) {
        Object.entries(ranges).forEach(([key, data]) => {
            const range = this.ranges[key];

            if (range) {
                range.update(data);
            }
        });
    }

    /**
     * Обновляет кнопку фильтра по данным с сервера
     * @param {string} count - строка с количеством найденных квартир
     * @private
     */
    _updateSubmit(count) {
        this.submit.classList.toggle(this.disableClass, !count);
        this.submit[count ? 'removeAttribute' : 'setAttribute']('disabled', '');

        this._replaceContent(this.submitText, count || 'Вариантов не найдено');
    }

    /**
     * Заменяет контент в блоке на переданный
     * @param {Element} element - целевой блок
     * @param {string} html - контент, который будет подставлен
     * @private
     */
    _replaceContent(element, html) {
        Utils.clearHtml(element);

        element.insertAdjacentHTML('beforeend', html);
    }

    /**
     * Показывает скрытые поля фильтра
     */
    _showAdditional() {
        if (!this.additionalRow || !this.additionalButton) {
            return;
        }

        if (!Utils.isMobile()) {
            this.additionalRow.style.height = this.additionalRow.classList.contains(this.openClass) ?
                `0px` :
                `${this.additionalRow.scrollHeight}px`;
        }

        this.additionalButton.classList.toggle(this.openClass);
        this.additionalRow.classList.toggle(this.openClass);


        this.additionalButtonText.innerText = this.additionalButton.classList.contains(this.openClass) ?
            this.openedButtonText :
            this.closedButtonText;
    }

    /**
     * Применяет данные с сервера
     * @param {object} data - данные с сервера
     * @param {string} reqType - тип произошедшего запроса
     */
    setFilter(data, reqType) {
        this.reqType = reqType;
        this._updateSubmit(data.count);

        if (data.filters) {
            this._updateFilters(data.filters);
        }

        if (data.sliders) {
            this._updateRanges(data.sliders);
        }

        this._calcInputs();
    }

    /**
     * Поведение при показе результатов
     */
    setResult() {
        this.popup.close();
    }

    /**
     * Запускает состояние ожидания
     * @param {boolean} isSubmitLoading - надо ли лоадить кнопку поиска
     */
    runLoading(isSubmitLoading = false) {
        this.element.classList.add(this.loadingClass);

        if (isSubmitLoading) {
            this.submit.classList.add(this.loadingClass);

            this.filterElems.forEach((elem) => {
                elem.classList.add(this.elemLoadingClass);
            });
        }
    }

    /**
     * Отменяет состояние ожидания
     */
    stopLoading() {
        if (!this.element) {
            return;
        }

        this.element.classList.remove(this.loadingClass);
        this.submit.classList.remove(this.loadingClass);
        this.filterElems.forEach((elem) => {
            elem.classList.remove(this.elemLoadingClass);
        });
    }

    /**
     * Возвращает форму
     * @returns {Element} - элемент формы
     */
    getForm() {
        if (!this.element) {
            return null;
        }

        return this.form;
    }

    /**
     * Проходит по рейнджам и конвертирует значения инпутов в числа
     * @param {object} formData - данные формы, в которой нужно переписать значения
     */
    convertRanges(formData) {
        if (!this.element) {
            return;
        }

        Object.values(this.ranges).forEach((range) => {
            const inputs = range.getInputs();

            inputs.forEach((input, index) => {
                const name = input.name;
                const val = parseFloat(input.value.replace(/\s+/g, ''));

                const isChanged = index === 0 ? range.changeFrom : range.changeTo;

                if (isChanged) {
                    formData.set(name, val);
                } else {
                    formData.delete(name);
                }
            });
        });
    }

    getFilterCount() {
        this.inputsForm = Array.from(this.form.querySelectorAll('input'));

        this.buttonCounter = document.querySelector('.j-button__counter');

        this._calcInputs();

        // this.inputsForm.forEach((input) => {
        //     input.addEventListener('input', () => {
        //         this._calcInputs();
        //     });
        // });

        // observer.subscribe('rangeSliderFinish', () => {
        //     this._calcInputs();
        // });

        observer.subscribe('formReset', () => {
            this._calcInputs();

            this.constructorButtons.forEach((item) => {
                item.querySelector('input').checked = false;
            });
        });
    }

    getVisualParams() {
        const result = new URLSearchParams();

        this.visualParamInputs.forEach((item) => {
            if (item.checked) {
                result.append(item.name, item.value);
            }
        });

        return result.toString();
    }

    /**
     * Проверяет выбран ли хотя бы один слайдер
     * @param {Element} elem - элемент слайдера
     * @returns {boolean} изменен слайдер или нет
     */
    _checkSlider(elem) {
        let isSelected = false;
        const inputs = elem.querySelectorAll('input');

        inputs.forEach((input) => {
            if (input.dataset.initValue !== input.value) {
                isSelected = true;
            }
        });

        return isSelected;
    }

    /**
     * Пересчитывает счетчик фильтров
     * @private
     */
    _calcInputs() {
        this.counter = 0;

        this.filterElems.forEach((elem) => {
            const inputs = [...elem.querySelectorAll('input')];
            const elemIsSlider = elem.querySelector('.j-range-slider');
            const elemIsProps = elem.dataset['filter'] === 'props';
            let selected = 0;

            if (elemIsSlider) {
                selected = Number(this._checkSlider(elem));
            } else if (elemIsProps) {
                selected = inputs.reduce((acc, input) => {
                    return input.checked ? acc + 1 : acc;
                }, 0);
            } else {
                selected = Number(inputs.some((input) => {
                    return input.checked;
                }));
            }

            this.counter = this.counter + selected;
        });

        if (this.buttonCounter) {
            if (this.counter) {
                this.buttonCounter.innerText = this.counter;
                this.buttonCounter.classList.add('is-active');
            } else {
                this.buttonCounter.innerText = '';
                this.buttonCounter.classList.remove('is-active');
            }
        }
    }

    /**
     * Находит в списке групп секций нужную - по названию секции
     * @param {string} title - название секции
     * @param {Object} sectionsGroup - группа секций (массив HTML-узлов)
     * @returns {Element} - нужная секция из массив
     */
    _findSectionByTitle(title, sectionsGroup) {
        let result = null;

        sectionsGroup.forEach((section) => {
            const label = section.querySelector('.j-custom-select__group-checkbox').dataset.text.slice(7);

            if (label === title) {
                result = section;
            }
        });

        return result;
    }

    /**
     * Запускаем фильтр доступных секций , если фильтр секций приходит. При условии что хотя бы 1 секция будет активна, селект с фильтром будет отображен.
     * @param {object} data - список всех фильтров
     */
    _updateSectionFilter(data) {
        const selectInput = this.sectionsSelect.querySelector('.j-custom-select__input');
        const sectionsGroup = this.sectionsSelect.querySelectorAll('.j-custom-select__group');
        let blockIsSelected = false;

        // Проверяем выбранны ли какие либо корпуса, если нет, то блокируем выбор секций
        if (data && 'blocks' in data) {
            data.blocks.items.forEach((block) => {
                if (block.checked) {
                    blockIsSelected = true;
                }
            });

            if (!blockIsSelected) {
                selectInput.classList.add(this.disableClass);

                return;
            }
        }

        // Если корпуса были выбраны, то проверяем ответ бека и проставляем группам с не активными элементами скрывающий класс
        if (data && 'section' in data) {
            const isArray = Array.isArray(data.section.items);

            if (isArray) {
                data.section.items?.forEach((options, index) => {
                    if (this._checkActiveSection(options)) {
                        sectionsGroup[index].classList.remove(this.disableClass);
                    } else {
                        sectionsGroup[index].classList.add(this.disableClass);
                    }
                });
            } else {
                const optionsArray = Object.values(data.section.items);
                const keysArray = Object.keys(data.section.items);

                optionsArray?.forEach((options, index) => {
                    const key = keysArray[index];
                    const section = this._findSectionByTitle(key, sectionsGroup);

                    if (this._checkActiveSection(options)) {
                        section.classList.remove(this.disableClass);
                    } else {
                        section.classList.add(this.disableClass);
                    }
                });
            }
        }

        selectInput.classList.remove(this.disableClass);
    }

    /**
     * Проверяет массив элементов списка на наличие активного элемента в каждой группе
     * @param {array} options - массив грцпп с опциями селекта
     * @returns {boolean} - возвращает правду или ложь
     */
    _checkActiveSection(options) {
        let active = false;

        options.forEach((option) => {
            if (option.disabled === false) {
                active = true;
            }
        });

        return active;
    }
}

export default ParametricFilter;
